export default "__VITE_ASSET__CzgoXNEx__"